import React from 'react'
import { miniHowItWorksStyle as styles } from './miniHowItWorks.tailwind'
import miniHowItWorksData from './miniHowItWorks.data'

const getIcon = (iconName) => {
  switch (iconName) {
    case 'bolt':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" />
        </svg>
      )
    case 'star':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499c.195-.39.765-.39.96 0l2.22 4.49 4.96.72c.43.063.602.583.29.89l-3.59 3.49.85 4.94c.07.41-.365.73-.74.54L12 16.18l-4.43 2.33c-.375.19-.81-.13-.74-.54l.85-4.94-3.59-3.49c-.312-.307-.14-.827.29-.89l4.96-.72 2.22-4.49z" />
        </svg>
      )
    case 'trophy':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 2a4 4 0 0 0-4 4v4a4 4 0 0 0 8 0V6a4 4 0 0 0-4-4Z" />
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 6H4.5a2.5 2.5 0 0 0 0 5H6" />
          <path strokeLinecap="round" strokeLinejoin="round" d="M18 6h1.5a2.5 2.5 0 0 1 0 5H18" />
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 14v4" />
          <path strokeLinecap="round" strokeLinejoin="round" d="M8 18h8" />
          <path strokeLinecap="round" strokeLinejoin="round" d="M7 22h10" />
        </svg>
      )
    case 'heart':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" />
        </svg>
      )
    default:
      return null
  }
}

const MiniHowItWorks = () => {
  return (
    <section className={styles.section_wrapper}>
      <div className={styles.container}>
        {/* Centered Heading */}
        <div className={styles.header_wrpr}>
          <h2 className={styles.heading}>
            BUILT FOR FANS <br />
            <span className={styles.highlight}>WHO GIVE A DAMN</span>
          </h2>
        </div>

        {/* Steps List */}
        <div className={styles.list_container}>
          {miniHowItWorksData.map((step) => (
            <div key={step.id} className={styles.step_row}>
              {/* Circle Icon Badge */}
              <div className={styles.icon_circle}>
                {getIcon(step.icon)}
              </div>
              {/* Content column */}
              <div className={styles.content_wrpr}>
                <h3 className={styles.title}>{step.title}</h3>
                <p className={styles.text}>{step.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default MiniHowItWorks
